<template>
  <!-- Deposit Checkout Detail start -->
  <div>
    <div class="fs-l fw-bold">
      {{ $vuetify.lang.t("$vuetify.deposit.card1.title") }}
    </div>
    <div class="checkout-detail-row">
      <div class="fs-l fw-bold">
        {{ $vuetify.lang.t("$vuetify.checkout.subtotal") }}
      </div>
      <div class="checkout-subtotal-amount">
        {{ getAmount | currency(true) }}
      </div>
    </div>
    <spacer size="m" border-bottom></spacer>
    <spacer size="m"></spacer>

    <template>
      <section
        class="fw-bold start-xs fs-l"
        v-if="
          (getDepositBonusByAmount && getDepositBonusByAmount.bonusCash > 0) ||
            (getDepositPointsByAmount &&
              getDepositPointsByAmount.bonusPoints > 0)
        "
      >
        {{ $vuetify.lang.t("$vuetify.checkout.bonus") }}
      </section>

      <template
        v-if="getDepositBonusByAmount && getDepositBonusByAmount.bonusCash > 0"
      >
        <spacer size="m"></spacer>
        <div class="checkout-detail-row">
          <span class="fs-l fc-black fw-bold"
            >{{ getDepositBonusByAmount.bonusCash | currency(true) }}
            {{ $vuetify.lang.t("$vuetify.checkout.bonus") }}</span
          >
          <span class="checkout-bonus-value"
            >+ {{ getDepositBonusByAmount.bonusCash | currency(true) }}</span
          >
        </div>
      </template>

      <template
        v-if="
          getDepositPointsByAmount && getDepositPointsByAmount.bonusPoints > 0
        "
      >
        <spacer size="m"></spacer>
        <div class="checkout-detail-row">
          <span class="fs-l fc-black fw-bold"
            >{{ getDepositPointsByAmount.bonusPoints }} {{ $vuetify.lang.t("$vuetify.checkout.points") }}</span
          >
          <span class="checkout-bonus-value"
            >+ {{ getDepositPointsByAmount.bonusPoints }} {{ $vuetify.lang.t("$vuetify.checkout.points") }}</span
          >
        </div>
      </template>
      <spacer size="m" border-bottom></spacer>
      <spacer size="m"></spacer>
    </template>

    <div class="fs-l fw-bold">
      {{ $vuetify.lang.t("$vuetify.checkout.depositDetails") }}
    </div>
    <spacer size="m"></spacer>
    <div class="checkout-detail-row">
      <span class="fs-s fc-black fw-bold">
        {{ $vuetify.lang.t("$vuetify.checkout.depositTo") }}
      </span>
      <span class="fs-s fc-black fw-bold">
        {{ depositDetails.telephone | phoneNumber }}
      </span>
    </div>
    <spacer size="s"></spacer>
    <div class="fs-xs fc-black">
      {{ $vuetify.lang.t("$vuetify.checkout.depositDirectlyToAccount") }}
    </div>
    <spacer size="m" border-bottom></spacer>
  </div>
  <!-- Deposit Checkout Detail end -->
</template>

<script>
import Spacer from "../../common/Spacer.vue";

export default {
  name: "deposit-review",
  components: {
    Spacer,
  },
  props: {
    getAmount: {
      type: Number,
      required: true,
    },
    getDepositBonusByAmount: {
      type: Object,
      required: false,
      default: null,
    },
    getDepositPointsByAmount: {
      type: Object,
      required: false,
      default: null,
    },
    depositDetails: {
      type: Object,
      required: true,
    },
  },
};
</script>
